(function () {
  const promoCache = new Map();
  const PER_PAGE = 12;

  /* ----------------------------------
     PROMO INSERTION (FINAL + STABLE)
  ---------------------------------- */
  function insertPromo(section, params) {
    if (params.tag !== 'All' || params.page !== 1) return;

    const promos = promoCache.get(section.dataset.sectionId) || [];
    if (!promos.length) return;

    const grid = section.querySelector('.lookbook-grid');

    // Ensure single promo only
    grid.querySelectorAll('.lookbook-promo').forEach(p => p.remove());

    const promo = promos[0];
    const node = promo.node.cloneNode(true);

    const visibleProducts = Array.from(
      grid.querySelectorAll('.lookbook-item')
    ).filter(item => item.style.display !== 'none');

    const insertIndex = promo.index - 1; // index is 1-based in UI

    if (visibleProducts[insertIndex]) {
      grid.insertBefore(node, visibleProducts[insertIndex]);
    } else {
      grid.appendChild(node);
    }
  }

  /* ----------------------------------
     PRODUCT RENDERING (CUSTOM PAGINATION)
  ---------------------------------- */
  function renderProducts(section, params, append = false) {
    const grid = section.querySelector('.lookbook-grid');
    const loadMoreBtn = section.querySelector('.lookbook-load-more');
    const shopAllBtn = section.querySelector('.lookbook-shop-all');

    const allItems = Array.from(grid.querySelectorAll('.lookbook-item'));
    const activeType = params.type;
    const activeTag = params.tag || 'All';

    const hasPromo =
      activeTag === 'All' &&
      params.page === 1 &&
      promoCache.get(section.dataset.sectionId)?.length;

    const productLimit = hasPromo ? PER_PAGE - 1 : PER_PAGE;

    const filtered = allItems.filter(item => {
      if (item.dataset.type !== activeType) return false;
      if (
        activeTag !== 'All' &&
        !item.dataset.tags.split(',').includes(activeTag)
      ) return false;
      return true;
    });

    let shown = parseInt(grid.dataset.shown || '0', 10);
    if (!append) shown = 0;

    if (!append) {
      allItems.forEach(item => (item.style.display = 'none'));
    }

    const slice = filtered.slice(shown, shown + productLimit);
    slice.forEach(item => (item.style.display = ''));

    shown += slice.length;
    grid.dataset.shown = shown;

    loadMoreBtn.style.display = shown < filtered.length ? '' : 'none';

    /* Show "Shop All" only for Type 2 (Hair Care) */
    const type1 = section.querySelector('.lookbook-tab')?.dataset.type;
    if (shopAllBtn) {
      shopAllBtn.style.display = activeType !== type1 ? '' : 'none';
    }

    // Promo ONLY on first render, AFTER products are visible
    if (!append) insertPromo(section, params);
  }

  /* ----------------------------------
     TAG VISIBILITY
  ---------------------------------- */
  function syncTags(section, activeType) {
    section.querySelectorAll('.lookbook-tag').forEach(tag => {
      if (
        tag.dataset.tag === 'All' ||
        !tag.dataset.type ||
        tag.dataset.type === activeType
      ) {
        tag.style.display = '';
      } else {
        tag.style.display = 'none';
      }
    });

    section
      .querySelectorAll('.lookbook-tag')
      .forEach(t => t.classList.remove('is-active'));

    section
      .querySelector('.lookbook-tag[data-tag="All"]')
      ?.classList.add('is-active');
  }

  /* ----------------------------------
     EVENTS
  ---------------------------------- */
  document.addEventListener('click', function (e) {
    const section = e.target.closest('.home-lookbook');
    if (!section) return;

    let activeType =
      section.querySelector('.lookbook-tab.is-active')?.dataset.type;

    if (e.target.matches('.lookbook-tab')) {
      section
        .querySelectorAll('.lookbook-tab')
        .forEach(t => t.classList.remove('is-active'));

      e.target.classList.add('is-active');
      activeType = e.target.dataset.type;

      syncTags(section, activeType);
      gridReset(section);

      renderProducts(
        section,
        { type: activeType, tag: 'All', page: 1 },
        false
      );
      return;
    }

    if (e.target.matches('.lookbook-tag')) {
      section
        .querySelectorAll('.lookbook-tag')
        .forEach(t => t.classList.remove('is-active'));

      e.target.classList.add('is-active');
      gridReset(section);

      renderProducts(
        section,
        {
          type: activeType,
          tag: e.target.dataset.tag,
          page: 1
        },
        false
      );
      return;
    }

    if (e.target.matches('.lookbook-load-more')) {
      const activeTag =
        section.querySelector('.lookbook-tag.is-active')?.dataset.tag || 'All';

      renderProducts(
        section,
        {
          type: activeType,
          tag: activeTag,
          page: 2
        },
        true
      );
    }
  });

  function gridReset(section) {
    const grid = section.querySelector('.lookbook-grid');
    grid.dataset.shown = '0';
    grid.querySelectorAll('.lookbook-promo').forEach(p => p.remove());
  }

  /* ----------------------------------
     INITIAL LOAD
  ---------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.home-lookbook').forEach(section => {
      const activeTab = section.querySelector('.lookbook-tab.is-active');
      if (!activeTab) return;

      const activeType = activeTab.dataset.type;

      const promos = Array.from(section.querySelectorAll('.lookbook-promo'));

      promoCache.set(
        section.dataset.sectionId,
        promos.map(promo => {
          promo.remove();
          return {
            node: promo.cloneNode(true),
            index: parseInt(promo.dataset.index, 10) || 1
          };
        })
      );

      syncTags(section, activeType);

      renderProducts(
        section,
        { type: activeType, tag: 'All', page: 1 },
        false
      );
    });
  });
})();
